import React from 'react'

import anchorsPageStyle from '../../styles/components/anchorsPage/anchors_page'
import homePageStyle from '../../styles/components/homePage/home_page'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import AdUnit from '../Ads/AdUnit'
import UnresetCSS from '../UnresetCSS'
import AnchorCard from './AnchorCard'

import Head from 'next/head'

const AnchorsPage = ({ pageTitle, title, thumbnail, description, anchors }) => (
  <>
    <Head>
      <title>{pageTitle}</title>
    </Head>
    {/* <Metadata metadata={{ thumbnail, description, title }} /> */}
    <div className='main-layout-container'>
      <div className='main-layout' data-testid='anchors'>
        <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-top'} type='leaderboardRedesign' />
        <h1 className='anchors-heading'>{title}</h1>
        <div className='anchors-section'>
          {anchors?.map(anchor => (
            <AnchorCard anchor={anchor} key={anchor?.id} />
          ))}
        </div>
      </div>
      <div className='main-layout-sidebar'>
        <AdUnit adUnitTemplate='rectangleVertical' id={'ad-banner-sidebar-top'} type='homePageSidebar' />
      </div>
      <style jsx>{homePageStyle}</style>
      <style jsx>{anchorsPageStyle}</style>
      <style jsx global>
        {structure}
      </style>
      <UnresetCSS />
      <BaseCSS />
    </div>
  </>
)

export default AnchorsPage
